import styled from 'styled-components';
import StyledSelect from 'components/ui/StyledSelect';
import { common } from 'themes/default';

export const FlexWrapper = styled.div`
  display: flex;

  & select {
    border-radius: 3px;
  }

  & button {
    margin-top: 10px;
    height: 38px;
  }
`;

export const CancellationFeeWrapper = styled.div`
  margin: 20px 0;
`;

export const CancellationFeeInput = styled.div`
  padding: 10px;
`;

export const CancellationReasonSelect = styled.div`
  padding: 10px 10px 10px 0;
`;

export const CancellationFeeMessage = styled.div`
  margin-left: 10px;
  font-style: italic;
`;

export const StyledNoRevert = styled.div`
  color: red;
`;

export const StyledDropdown = styled(StyledSelect)`
  display: block;
  height: 32px;
  margin: 10px 0;
`;

export const StyledManageSubscriptionWrapper = styled.div`
  display: flex;

  & button:nth-child(1) {
    margin-right: 10px;
  }
`;

export const StyledCoolingOffPeriod = styled.div`
  margin: 15px;
`;

export const StyledMessageCoolingOff = styled.div`
  margin: 10px 0;
`;

export const StyledInfos = styled.div`
  background: ${common.notifications.information.backgroundColour};
  border-radius: 3px;
  color: ${common.notifications.information.fontColour};
  padding: 8px 16px;
`;
